import React from 'react';

export default function ReferenceCell({ value }) {
  return <span>{value || ''}</span>;
}
